import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";

/**
 * Figma 7537:57580 ("Investing Essentials" mini row) and 7546:57732
 * ("Private Wealth" gold "Component 300") — a compact plan-group header
 * with an icon, title and "N ACTIVE PLAN" badge.
 */
const PlanGroupHeader = ({
  icon,
  iconWidth = 38,
  iconHeight = 38,
  title,
  activeCount = 0,
  variant = "light",
}) => {
  const isGold = variant === "gold";

  const badge = (
    <Box
      sx={{
        bgcolor: isGold ? "rgba(0,0,0,0.14)" : "#F8FAFC",
        borderRadius: "6px",
        px: 1.25,
        py: 0.5,
        flexShrink: 0,
        width: "fit-content",
      }}
    >
      <Text
        sx={{
          fontWeight: 700,
          fontSize: "12px",
          color: isGold ? "#fff" : "#3B82F6",
          whiteSpace: "nowrap",
        }}
      >
        {activeCount} ACTIVE PLAN
      </Text>
    </Box>
  );

  const iconAndTitle = (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Box
        component="img"
        src={icon}
        alt=""
        sx={{
          width: iconWidth,
          height: iconHeight,
          objectFit: "contain",
          filter: isGold
            ? "drop-shadow(0px 4px 4px rgba(0,0,0,0.25))"
            : "drop-shadow(0px 0px 13px rgba(0,0,0,0.25))",
        }}
      />
      <Text
        sx={{
          fontWeight: isGold ? 800 : 700,
          fontSize: isGold ? "24px" : "20px",
          letterSpacing: isGold ? "-0.03em" : "normal",
          color: isGold ? "#3E2B03" : "#111827",
        }}
      >
        {title}
      </Text>
    </Stack>
  );

  return (
    <Box
      sx={
        isGold
          ? {
              borderRadius: "24px",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0px 0px 4.5px rgba(0,0,0,0.12)",
              background:
                "linear-gradient(125deg, #F9E8C0 1.2%, #F0D899 98.9%)",
              px: 3,
              pt: 3,
              pb: { xs: "34px", md: 4.25 },
            }
          : {
              bgcolor: "#fff",
              border: "1px solid #E2E8F0",
              borderRadius: "12px",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.02)",
              px: 3,
              py: { xs: "22px", md: 2.75 },
            }
      }
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent={{ xs: "flex-start", md: "space-between" }}
        spacing={{ xs: "10px", md: 2 }}
      >
        {iconAndTitle}
        {badge}
      </Stack>
    </Box>
  );
};

export default PlanGroupHeader;
